<!-- 课程详情中的事件 -->
<template>
  <div>
    <!-- 文本工具 ? -->
    <div
      class="textTool-sty"
      :style="{
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        transform: 'scale(' + scale + ')',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: !noRotation
          ? 'rotate(' + item.rotation + 'deg)'
          : 'rotate(0deg)',
      }"
      v-for="(item, index) in data.uiTextVOs"
      :key="'textTool-sty'+item.id+index"
      :id="'t' + indexP + ',' + ind + ',' + index">
      <div
        class="text-con"
        :style="{
          width: item.posWidth + 'vw',
          transform: 'scale(' + scale + ')',
          'word-wrap': 'break-word',
          'word-break': 'break-word',
          'transform-origin': 'left top 0',
        }"
        v-html="ToCDB(item.content)"
      ></div>
    </div>

    <!-- 图片工具 OK -->
    <div
      class="imageTool-sty"
      v-for="(item, index) in data.uiImageVOs"
      :key="'imageTool-sty'+item.id+index"
      :class="{ active: item.selected }"
      :style="{
        position: 'absolute',
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <img
        :src="
          aliOsUrl(item.src) +
          '?v=' +
          new Date().getTime() +
          Math.random()
        "
        :style="{ width: '100%', height: '100%' }"
      />
    </div>

    <!-- 模型工具 OK -->
    <div
      class="modelTool-sty"
      v-for="(item, index) in data.uiModelVOs"
      :key="'modelTool-sty'+item.id+index"
      :class="{ active: item.selected }"
      :style="{
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <img
        src="@/assets/images/model-icon.png"
        :style="{
          width:
            (item.posWidth / 6 > item.posHeight - 10
              ? item.posHeight.scale
              : (item.posWidth / 12) * scale) + 'vw',
        }"
        class="modeIcon"
      />
      <div class="d-play-bg" @click.stop="modelPlay(item, 1)">
        <div
          class="img"
          :style="{
            width:
              (item.posWidth / 6 > item.posHeight - 10
                ? item.posHeight * scale
                : (item.posWidth / 6) * scale) + 'vw',
            height:
              (item.posWidth / 6 > item.posHeight - 10
                ? item.posHeight * scale
                : (item.posWidth / 6) * scale) + 'vw',
          }"
        ></div>
      </div>
      <img
        :src="
          aliOsUrl(item.coverImage) +
          '?v=' +
          new Date().getTime() +
          Math.random()
        "
        :style="{ width: '100%', height: '100%' }"
      />
    </div>

    <!-- 形状工具 ? -->
    <div
      class="shapeTool-sty"
      v-for="(item, index) in data.shapeList"
      :key="'shapeTool-sty'+item.id+index"
      :class="{ active: item.selected }"
      :style="{
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <div
        class="svg-wrap ql-editor"
        v-html="item.data"
        style="width: 100%; height: 100%"
      ></div>
    </div>

    <!-- 视频工具 OK -->
    <div
      class="videoTool-sty"
      v-for="(item, index) in data.uiVideoVOs"
      :key="'videoTool-sty'+item.id+index"
      :class="{ active: item.selected }"
      :style="{
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <img
        :src="aliOsUrl(item.coverImage) +
          '?v=' +
          new Date().getTime() +
          Math.random()
        "
        :style="{ width: '100%', height: '100%' }"
      />
      <div
        class="d-play-bg"
        @mousedown.stop=""
        @click.stop="modelPlay(item, 2)"
      >
          <img
            src="@/assets/images/3d_play_btn.png"
            :style="{
              width:
                (item.posWidth / 7 > item.posHeight - 10
                  ? item.posHeight * scale
                  : (item.posWidth / 7) * scale) + 'vw',
            }"
          />
      </div>
    </div>

    <!-- 音频工具 OK -->
    <div
      class="audioTool-sty"
      v-for="(item, index) in data.uiAudioVOs"
      :key="'audioTool-sty'+item.id+index"
      :class="{ active: item.selected, locked: item.isLock }"
      :style="{
        width: 220 * scale + 'vw',
        height: 70 * scale + 'vw',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <div
        class="audio-sty-div"
        :style="{
          width: 200 * scale + 'vw',
          height: 70 * scale + 'vw',
          lineHeight: 60 * scale + 'vw',
          padding: 5 * scale + 'vw',
          paddingLeft: 15 * scale + 'vw',
          fontSize: 16 * scale + 'vw',
        }"
      >
          <img
            src="@/assets/images/shape-icon.png"
            :style="{ marginRight: 8 * scale + 'vw' }"
            @click.stop="modelPlay(item, 3)"
          />
        <span>{{
          item.src.substring(item.src.lastIndexOf("/") + 1, item.src.length)
        }}</span>
      </div>
    </div>

    <!-- 表格工具 ? -->
    <div
      class="tableTool-sty"
      v-for="(item, index) in data.tableList"
      :key="'tableTool-sty'+item.id+index"
      :id="'tab' + indexP + ',' + ind + ',' + index"
      :class="{ active: item.selected }"
      :style="{
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        position: 'absolute',
        background: '#fff',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: !noRotation
          ? 'rotate(' + item.rotation + 'deg)'
          : 'rotate(0deg)',
      }">
      <table
        cellpadding="0"
        cellspacing="0"
        border="0"
        :style="{
          width: item.posWidth + 'vw',
          height: item.posHeight + 'vw',
          transform: 'scale(' + scale + ')',
        }"
      >
        <tr
          nowrap="nowrap"
          v-for="(its, trindex) in item.dataList"
          :key="trindex"
        >
          <td
            v-for="(td, tdindex) in its"
            :key="tdindex"
            :style="{
              width: td.width + 'vw',
              height: td.height + 'vw',
              borderStyle: td.borderStyle,
              borderTopWidth: td.borderTopWidth,
              borderTopColor: td.borderTopColor,
              borderRightWidth: td.borderRightWidth,
              borderRightColor: td.borderRightColor,
              borderBottomWidth: td.borderBottomWidth,
              borderBottomColor: td.borderBottomColor,
              borderLeftWidth: td.borderLeftWidth,
              borderLeftColor: td.borderLeftColor,
              overflow: 'hidden',
            }"
          >
            <div
              :style="{
                cursor: !item.edit ? 'unset' : '',
                'font-size': td.fontSize + 'vw',
                color: td.fontColor,
                'font-weight': td.bold,
                'text-align': td.align,
                'text-decoration': td.direction,
                'font-family': td.font,
              }"
              v-html="ToCDB(td.content)"
              class="con con-el ql-editor"
            ></div>
          </td>
        </tr>
      </table>
    </div>

    <!-- 图表工具 ? -->
    <div
      class="chartTool-sty"
      v-for="(item, index) in data.chartList"
      :key="'chartTool-sty'+item.id+index"
      :id="'chart' + indexP + ',' + ind + ',' + index"
      :class="{ active: item.selected }"
      :style="{
        width: item.posWidth * scale + 'vw',
        height: item.posHeight * scale + 'vw',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <template v-if="item.dataList">
        <!-- <v-chart
          :options="
            parseInt(item.chartType) === 1
              ? chartConfig.barConfig(item)
              : parseInt(item.chartType) === 2
              ? chartConfig.lineConfig(item)
              : chartConfig.pieConfig(item)
          "
          ref="echarts1"
          id="add"
        /> -->
      </template>
    </div>

    <!-- 二级页面工具 -->
    <div
      class="detailPageTool-sty"
      v-for="(item, index) in data.detailPageList"
      :key="'detailPageTool-sty'+item.id+index"
      :style="{
        width: 200 * scale + 'vw',
        height: 200 * scale + 'vw',
        position: 'absolute',
        left: item.posLeft * scale + 'vw',
        top: item.posTop * scale + 'vw',
        'z-index': item.zIndex,
        transform: 'rotate(' + item.rotation + 'deg)',
      }">
      <img
        src="@/assets/images/icon_ts_bg.png"
        class="animate__animated animate__pulse animate__infinite animate__faster detail-icon"
        :style="{ width: '26%', height: '26%' }"
        @click.stop="modelPlay(item, 4)"
      />
      <img
        src="@/assets/images/icon_ts_xian.png"
        :style="{ width: '19%', height: '19%' }"
        @click.stop="modelPlay(item, 4)"
        class='rotate detail-icon'
      />
      <img
        src="@/assets/images/icon_ts_images.png"
        :style="{ width: '14%', height: '14%' }"
        @click.stop="modelPlay(item, 4)"
        v-show="item.hasOwnProperty('imageId')"
        class='detail-icon'
      />
      <img
        src="@/assets/images/icon_ts_model.png"
        :style="{ width: '14%', height: '14%' }"
        @click.stop="modelPlay(item, 4)"
        v-show="item.hasOwnProperty('modelId')"
        class='detail-icon'
      />
      <img
        src="@/assets/images/icon_ts_mp4.png"
        :style="{ width: '14%', height: '14%' }"
        @click.stop="modelPlay(item, 4)"
        v-show="item.hasOwnProperty('videoId')"
        class='detail-icon'
      />
    </div>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: '',
  props: {
    data: { // 当前PPT数据详情
      type: Object,
      default: {} || ''
    },
    scale: { // PPT上面的二级功能图标的显示比例
      type: [String, Number],
      default: 1
    },
    indexP: {
      type: [String, Number],
      default: 0
    },
    ind: {
      type: [String, Number],
      default: 0
    },
    noRotation: {
      type: Boolean,
      default: false
    },
    chapterId: { // 章节ID
      type: [String, Number],
      default: null
    }
  },
  components: {
    // 'v-chart': ECharts
  },
  directives: {

  },
  data () {
    return {
    }
  },
  watch: {
    data (val) {
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    /**
     * 全角转半角
    */
    ToCDB (str) {
      if (!str) return ''
      let tmp = ''
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248)
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i))
        }
      }
      return tmp
    },
    /**
     * ali云os地址拼接
     * @param value oss地址
    */
    aliOsUrl  (path) {
      return aliyun.getAliyunAddress(path)
    },
    /**
     * 播放模型
     */
    modelPlay (item, playType) {
      const data = {
        ste: true,
        val: item,
        id: item.mid ? item.mid : item.id,
        type: playType,
        modelName: item.name,
        chapterId: this.chapterId
      }
      this.$emit('mPlay', data)
    }
  }
}

</script>
<style lang='scss'>
.d-play-bg {
  img,
  .img {
    width: 80px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
  }
}
.svg-wrap {
  svg {
    width: 100%;
    height: 100%;
  }
}
//二级页面
.detailPageTool-sty {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  // &.active {
  //   border: 1px dashed #000;
  // }
  .resizeRoate {
    position: absolute;
    bottom: -20px;
  }
  img {
    position: absolute;
  }
  // .rotate-in(@name) {
  //   @keyframes @name {
  //     from {
  //       transform: rotate(0);
  //     }
  //     to {
  //       transform: rotate(360deg);
  //     }
  //   }
  //   @-webkit-keyframes @name {
  //     from {
  //       transform: rotate(0);
  //     }
  //     to {
  //       transform: rotate(360deg);
  //     }
  //   }
  //   @-moz-keyframes @name {
  //     from {
  //       transform: rotate(0);
  //     }
  //     to {
  //       transform: rotate(360deg);
  //     }
  //   }
  //   @-o-keyframes @name {
  //     from {
  //       transform: rotate(0);
  //     }
  //     to {
  //       transform: rotate(360deg);
  //     }
  //   }
  // }
  // .rotate-in(rotateIn);
  // .animation(@animation-name,@animation-duration,@animation-timing-function,@animation-iteration-count) {
  //   -webkit-animation: @arguments;
  //   -moz-animation: @arguments;
  //   -ms-animation: @arguments;
  //   -o-animation: @arguments;
  //   animation: @arguments;
  // }
  // .rotate {
  //   .animation(rotateIn,2s,linear,infinite);
  // }
}
// 模型
.modelTool-sty {
  .d-play-bg {
    .img {
      background: url("../../../../assets/images/model-play.png") no-repeat;
      background-size: contain;
      background-position: center;
      // display: none;
      &:hover {
        background: url("../../../../assets/images/model-play-press.png")
          no-repeat;
        background-size: contain;
        background-position: center;
      }
    }
  }
  &:hover {
    .d-play-bg {
      .img {
        display: block;
      }
    }
  }
  .modeIcon {
    position: absolute;
    top: 0;
    right: 0;
    outline: none;
  }
}
// table工具
.tableTool-sty {
  table {
    border-collapse: collapse;
    transform-origin: left top 0px;
    -webkit-transform-origin: left top 0px;
    -moz-transform-origin: left top 0px;
    -ms-transform-origin: left top 0px;
    -o-transform-origin: left top 0px;
  }
  td {
    // border: 1px solid #666;
    position: relative;
    textarea {
      background-color: transparent;
      overflow: hidden;
      resize: none;
      border-style: none;
      width: 100%;
      height: 100%;
      color: rgb(0, 0, 0);
      outline: none;
      display: block;
    }
    .con-el {
      width: 100%;
      min-height: 30px;
      height: auto;
      // height: 100%;
      word-break: break-word;
      word-wrap: break-word;
      white-space: normal;
      outline: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
// 图表工具
.echarts {
  width: 100%;
  height: 100%;
}
.audio-sty-div {
  background-image: url("../../../../assets/images/audio-bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100%;
  img {
    vertical-align: middle;
    width: 19%;
    cursor: pointer;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 65%;
  }
}
</style>
